// Where Tab (or Shift+Tab) goes inside a modal: the next control, wrapping at both ends, so
// focus never leaves the dialog. Focus outside it comes back to the first (or last) control.
export function trapTabTarget<T>(focusables: T[], active: T | null, shift: boolean): T | null {
  if (focusables.length === 0) return null;
  const last = focusables.length - 1;
  const index = active === null ? -1 : focusables.indexOf(active);
  if (index === -1) return shift ? focusables[last] : focusables[0];
  if (shift) return index === 0 ? focusables[last] : focusables[index - 1];
  return index === last ? focusables[0] : focusables[index + 1];
}
